/* =====================================================================
   KARTOGRAF · SFONDI DELLE SEZIONI (13/10/2026)
   Si carica DOPO js/kg-sito.js. Stili in css/kg-sfondi.css, guida in css/LEGGIMI-sfondi.md
   Ogni effetto e' una classe sulla sezione + attributi data- facoltativi:
     data-kg-immagini="nome1,nome2,..."  foto vere (nome del file in img/ senza .jpg,
                                         oppure un percorso completo)
     data-kg-velocita="120"              durata di un giro in secondi (piu' alto = piu' lento)
     data-kg-ritmo="2600"                millisecondi tra un cambio e l'altro (effetti a turno)
     data-kg-direzione="inversa"         inverte il verso dello scorrimento
   Le tessere usano le miniature img/mini/ (crea: py strumenti/crea_mini.py).
   SHOPIFY (13/10/2026): miniature nei File del negozio con prefisso kgsf-:
     kgsf-<nome>.jpg (440 px) e kgsf-blur-<nome>.jpg (sfocata); la cartella dei File la da'
     <html data-kg-files="..."> (layout/theme.liquid), come per kg-sito.js. Un URL completo resta com'e'.
   ===================================================================== */
(function(){
  'use strict';
  var doc=document, html=doc.documentElement;
  var FILES=html.getAttribute('data-kg-files')||'';
  var mm=function(q){return window.matchMedia&&window.matchMedia(q).matches};
  var REDUCE=mm('(prefers-reduced-motion: reduce)');
  var PHONE=mm('(max-width: 860px)');
  var HOVER=mm('(hover: hover) and (pointer: fine)');
  var HAS_IO='IntersectionObserver' in window;
  function $$(s,c){return [].slice.call((c||doc).querySelectorAll(s))}
  /* Shopify: se una miniatura kgsf- manca, ripiega sulla foto intera kgs- (stesso nome) invece di un buco */
  doc.addEventListener('error',function(e){
    var t=e.target; if(!t||t.tagName!=='IMG'||t.getAttribute('data-kg-rip')) return;
    var s=t.getAttribute('src')||'', r=s.replace(/\/kgsf-(blur-)?/,'/kgs-');
    if(r!==s){t.setAttribute('data-kg-rip','1');t.setAttribute('src',r)}
  },true);

  /* foto di ripiego (le stesse del mosaico della home) */
  var DEF=['prod-kit-ristorante','prod-sito-social-start','prod-t-shirt-pezzo-unico-fronte-retro','prod-immagine-coordinata','prod-modellazione-3d','prod-shopper-serigrafate','prod-kit-workwear','prod-abbonamento-social-growth','prod-pannelli-forex-dibond-plexiglass','prod-etichette-adesive-personalizzate','prod-t-shirt-donna-oversize-personalizzata','prod-porta-qr-3d-da-tavolo'];

  function src(n,blur){
    if(/[\/]|\.(jpe?g|png|webp)$/i.test(n)) return n;
    return FILES+'kgsf-'+(blur?'blur-':'')+n+'.jpg';
  }
  function lista(el,attr,fb){
    var v=(el.getAttribute(attr||'data-kg-immagini')||'').split(',').map(function(s){return s.trim()}).filter(Boolean);
    return v.length?v:(fb||DEF);
  }
  function img(n,lazy,blur){return '<img alt="" decoding="async"'+(lazy===false?'':' loading="lazy"')+' src="'+src(n,blur)+'">'}
  function layer(host,cls){
    var old=host.querySelector(':scope>.kg-bgl.'+cls.split(' ')[0]); if(old) return null;
    var d=doc.createElement('div'); d.className='kg-bgl '+cls; d.setAttribute('aria-hidden','true');
    host.insertBefore(d,host.firstChild); return d;
  }
  function vel(host,el){
    var v=parseFloat(host.getAttribute('data-kg-velocita')); if(v>0) el.style.setProperty('--kg-v',v+'s');
    if(host.getAttribute('data-kg-direzione')==='inversa') el.style.animationDirection='reverse';
  }
  function ritmo(host,def){var r=parseInt(host.getAttribute('data-kg-ritmo'),10);return r>200?r:def}
  /* rettangoli dei testi della sezione: gli effetti "a turno" non si accendono sotto i testi */
  function testi(sec,sel){
    return $$(sel||'h1,h2,h3,p,.kg-eyebrow,.kg-lead,.kg-list,.kg-pricelist',sec).filter(function(t){
      return !t.closest('.kg-bgl,.kg-card,.kg-prod,.kg-offer,.kg-step,.kg-rev,.kg-plan,.kg-cat,.kg-tile');
    }).map(function(t){return t.getBoundingClientRect()});
  }
  function tocca(r,rs,m){m=m||0;for(var i=0;i<rs.length;i++){var q=rs[i];if(r.left<q.right+m&&r.right>q.left-m&&r.top<q.bottom+m&&r.bottom>q.top-m)return true}return false}

  /* ---------- visibilita': ferma tutto fuori schermo ---------- */
  var VIS=new WeakMap();
  function visibile(el){return VIS.get(el)!==false&&!doc.hidden}
  var pio=HAS_IO?new IntersectionObserver(function(es){
    es.forEach(function(e){VIS.set(e.target,e.isIntersecting);e.target.classList.toggle('kg-paused',!e.isIntersecting)});
  },{rootMargin:'160px 0px'}):null;
  function osserva(el){if(pio){VIS.set(el,false);pio.observe(el)}}
  function ogni(el,ms,fn){ /* timer che lavora solo se l'elemento e' a schermo */
    if(REDUCE) return;
    setInterval(function(){if(visibile(el)) fn()},ms);
  }

  /* ---------- FILE CHE SCORRONO SEMPRE PIENE (fix offerte 13/10, Diego) ----------
     Nastri in diagonale, righe della K, feed e colonne: ogni fila e' fatta di 2 meta' identiche e l'animazione
     (kg-x / kg-y) la sposta di una meta'. Se la meta' e' piu' corta della scatola da coprire, a fine giro (e a inizio
     giro nei nastri al contrario) resta un pezzo vuoto: era la fascia delle offerte che "partiva da meta'".
     giro() ripete il blocco di tessere quanto serve (meta' >= scatola + 1 tessera: nei nastri la fila intera supera
     3 volte lo schermo), aggiunge in coda uno spazio pari al gap (cosi' -50% = esattamente un giro, niente scatto),
     allunga la durata nella stessa misura (velocita' invariata), parte da un punto a caso del giro (ritardo negativo)
     e si rifa' quando cambia la misura. Le tessere si caricano tutte quando la sezione si avvicina: le lazy fuori dal
     ritaglio della sezione entravano vuote. */
  function carica(host){$$('.kg-giro>img[loading]',host).forEach(function(i){i.removeAttribute('loading')})}
  var VIC=HAS_IO?new IntersectionObserver(function(es){
    es.forEach(function(e){if(!e.isIntersecting) return; VIC.unobserve(e.target); e.target.setAttribute('data-kg-vicino',''); carica(e.target)});
  },{rootMargin:'1000px 0px'}):null;
  function giro(row,blocco,quanto,vert,host,oss){
    var k=(blocco.match(/<img/g)||[]).length, rip=0, fase=Math.random();
    if(!k) return;
    row.classList.add('kg-giro');
    function fai(){
      var nuovo=!rip;
      if(nuovo){rip=1; row.innerHTML=blocco+blocco}
      var ims=row.children, p=vert?ims[k].offsetTop-ims[0].offsetTop:ims[k].offsetLeft-ims[0].offsetLeft;
      if(p>0){
        var t=vert?ims[0].offsetHeight:ims[0].offsetWidth, r=Math.max(1,Math.ceil((quanto()+t)/p));
        if(r!==rip){rip=r; var h=''; for(var i=0;i<2*r;i++) h+=blocco; row.innerHTML=h; nuovo=true}
      }
      if(nuovo&&(!VIC||host.hasAttribute('data-kg-vicino'))) carica(row.parentNode);
      var cs=getComputedStyle(row), g=parseFloat(vert?cs.rowGap:cs.columnGap)||0;
      row.style.animationDuration=''; row.style.animationDelay='';
      var d=(parseFloat(getComputedStyle(row).animationDuration)||0)*rip;
      row.style[vert?'paddingBottom':'paddingRight']=g+'px';
      if(d>0){row.style.animationDuration=d.toFixed(2)+'s'; row.style.animationDelay=(-fase*d).toFixed(2)+'s'}
    }
    fai();
    if(VIC&&!host.__kgVic){host.__kgVic=1; VIC.observe(host)}
    if(window.ResizeObserver){var t0, w0=-1; new ResizeObserver(function(){
      var w=vert?oss.offsetHeight:oss.offsetWidth; if(w===w0) return; w0=w; clearTimeout(t0); t0=setTimeout(fai,150);
    }).observe(oss)}
  }

  /* ---------- 1. FASCIA CHE SCORRE con mini-tessere ---------- */
  $$('.kg-marquee--tessere').forEach(function(m){
    var hero=doc.querySelector('.kg-main>.kg-hero');
    var fb=hero&&hero.getAttribute('data-kg-mosaic')?lista(hero,'data-kg-mosaic'):DEF;
    var pics=lista(m,'data-kg-tessere',fb.slice(0,8)), k=0;
    $$('.kg-marquee__in>i',m).forEach(function(i){
      i.innerHTML='<span class="kg-tess">'+img(pics[k++%pics.length],false)+'</span>';
    });
    osserva(m);
  });
  /* il mosaico B e le fasce senza tessere si fermano comunque fuori schermo */
  $$('.kg-mosaic,.kg-marquee:not(.kg-marquee--tessere),.kg-bento--vivo,.kg-sec--fantasma').forEach(osserva);

  /* ---------- 2. SERVIZI: kg-bg--accendi ---------- */
  $$('.kg-bg--accendi').forEach(function(sec){
    var L=layer(sec,'kg-acc'); if(!L) return;
    var cards=$$('[data-kg-bg]',sec); if(!cards.length) return;
    var sets=cards.map(function(c){return lista(c,'data-kg-bg')});
    var mix=[]; for(var j=0;j<4;j++) sets.forEach(function(s){if(s[j]&&mix.indexOf(s[j])<0) mix.push(s[j])});
    var T=parseInt(sec.getAttribute('data-kg-tessera'),10)||(PHONE?104:168);
    var grids=[], cols=0, n=0, cur=-1, at=-1;
    function build(){
      var w=sec.offsetWidth, h=sec.offsetHeight;
      var c=Math.max(3,Math.round(w/(T+6))), r=Math.ceil(h/(w/c))+1;
      if(c===cols&&c*r===n) return; cols=c; n=c*r;
      L.style.setProperty('--kg-c',c); L.style.setProperty('--kg-t',(w/c-6)+'px');
      if(!grids.length){
        L.innerHTML='<div class="kg-acc__g kg-acc__base"></div><div class="kg-acc__g kg-acc__on"></div><div class="kg-acc__g kg-acc__on"></div>';
        grids=$$('.kg-acc__g',L);
      }
      fill(grids[0],mix,true); fill(grids[1],[],false); fill(grids[2],[],false); cur=-1; at=-1;
    }
    function fill(g,pics,lazy){
      var h='';
      if(pics.length) for(var i=0;i<n;i++) h+=img(pics[(i%cols+Math.floor(i/cols)*3)%pics.length],lazy);
      g.innerHTML=h;
    }
    function setImgs(g,pics){
      if(g.children.length!==n){fill(g,pics,false);return}
      var im=g.children;
      for(var i=0;i<im.length;i++){var s=src(pics[(i%cols+Math.floor(i/cols)*3)%pics.length]); if(im[i].getAttribute('src')!==s) im[i].setAttribute('src',s)}
    }
    function accendi(k,card){
      cards.forEach(function(c){c.classList.toggle('is-guida',c===card&&!HOVER)});
      if(k===cur) return;
      if(k<0){grids[1].classList.remove('is-on');grids[2].classList.remove('is-on');sec.classList.remove('is-acceso');cur=-1;return}
      var nx=at===1?2:1, pv=at===1?1:2;
      setImgs(grids[nx],sets[k]);
      grids[nx].classList.add('is-on'); if(at>0) grids[pv].classList.remove('is-on');
      at=nx; cur=k; sec.classList.add('is-acceso');
    }
    var pre=false;
    function precarica(){if(pre) return; pre=true; sets.forEach(function(s){s.forEach(function(p){var i=new Image();i.decoding='async';i.src=src(p)})})}
    build();
    if(window.ResizeObserver){var t0;new ResizeObserver(function(){clearTimeout(t0);t0=setTimeout(build,200)}).observe(sec)}
    if(HOVER){
      sec.addEventListener('mouseenter',precarica);
      cards.forEach(function(c,k){
        c.addEventListener('mouseenter',function(){accendi(k,c)});
        c.addEventListener('focus',function(){accendi(k,c)});
      });
      sec.addEventListener('mouseleave',function(){accendi(-1)});
    }else if(HAS_IO){
      /* telefono: comanda la card al centro dello schermo */
      new IntersectionObserver(function(es){if(es[0].isIntersecting) precarica()},{rootMargin:'400px 0px'}).observe(sec);
      var vis=new Map();
      var cio=new IntersectionObserver(function(es){
        es.forEach(function(e){vis.set(e.target,e.isIntersecting)});
        var on=cards.filter(function(c){return vis.get(c)});
        if(on.length) accendi(cards.indexOf(on[0]),on[0]); else accendi(-1);
      },{rootMargin:'-42% 0px -42% 0px'});
      cards.forEach(function(c){cio.observe(c)});
    }
  });

  /* ---------- 3. OFFERTE: kg-bg--diagonale ---------- */
  $$('.kg-bg--diagonale').forEach(function(sec){
    var L=layer(sec,'kg-dia'); if(!L) return;
    var pics=lista(sec), a=sec.getAttribute('data-kg-angolo');
    if(a) L.style.setProperty('--kg-a',parseFloat(a)+'deg'); else L.style.setProperty('--kg-a',PHONE?'-7deg':'-5deg');
    /* un blocco = tutte le foto una volta; giro() lo ripete finche' il nastro copre la sua fascia (160% della sezione) */
    var blocco=function(off){var h='';for(var j=0;j<pics.length;j++)h+=img(pics[(j+off)%pics.length]);return h};
    var h='<div class="kg-dia__band kg-dia__band--1"><div class="kg-dia__row"></div></div>';
    if(sec.getAttribute('data-kg-nastri')!=='1') h+='<div class="kg-dia__band kg-dia__band--2"><div class="kg-dia__row"></div></div>';
    L.innerHTML=h; vel(sec,L); osserva(L);
    $$('.kg-dia__row',L).forEach(function(rw,i){
      var band=rw.parentNode;
      giro(rw,blocco(i?Math.floor(pics.length/2):0),function(){return Math.max(band.offsetWidth,window.innerWidth*1.6)},false,sec,band);
    });
  });

  /* ---------- 4. PRODOTTI: kg-bg--k (la K del logo ritagliata sul mosaico) ----------
     data-kg-k="finestra" (predefinito): la K intera nello spazio libero tra titolo e testo
     dell'intestazione; se lo spazio non basta (o sul telefono) diventa una K gigante tenue a destra.
     data-kg-k="sinistra|centro|destra": K gigante alta quanto la sezione. data-kg-k3d: ruota piano. */
  var KS=[];
  function kplace(o){
    if(o.pos!=='finestra') return;
    var box=o.box, sec=o.sec, ok=false;
    var head=sec.querySelector('.kg-head'), h2=head&&head.querySelector('h2,.kg-h2'), side=head&&head.querySelector('.kg-head__side');
    if(!PHONE&&h2&&side){
      var sr=sec.getBoundingClientRect(), rg=doc.createRange(); rg.selectNodeContents(h2);
      var tr=rg.getBoundingClientRect(), sd=side.getBoundingClientRect();
      var nx=head.nextElementSibling, gt=nx?nx.getBoundingClientRect().top:sd.bottom;
      /* margine alto +10 px di riserva per la parallasse: la K non sale mai sopra il bordo o sul taglio rosso (AD 13/10) */
      var top0=(sec.previousElementSibling&&sec.previousElementSibling.classList.contains('kg-sec--creativa')?52:16)+10;
      var gap=sd.left-tr.right-56, avail=gt-sr.top-top0-6, hk=Math.min(avail,gap*1150/897,460);
      if(hk>=150){
        ok=true; var wk=hk*897/1150;
        box.style.height=hk.toFixed(0)+'px'; box.style.width=wk.toFixed(0)+'px';
        box.style.left=(tr.right-sr.left+28+(gap-wk)/2).toFixed(0)+'px';
        box.style.top=(top0+(avail-hk)/2).toFixed(0)+'px';
      }
    }
    box.classList.toggle('kg-kbox--finestra',ok);
    box.classList.toggle('kg-kbox--destra',!ok); box.classList.toggle('kg-kbox--tenue',!ok);
    if(!ok){box.style.height=box.style.width=box.style.left=box.style.top=''}
  }
  $$('.kg-bg--k').forEach(function(sec){
    var L=layer(sec,'kg-kl'); if(!L) return;
    var pics=lista(sec), pos=sec.getAttribute('data-kg-k')||'finestra';
    var rows=PHONE?6:9, h='', blocchi=[];
    for(var r=0;r<rows;r++){
      var row='', off=(r*3)%pics.length;
      for(var j=0;j<pics.length;j++)row+=img(pics[(j+off)%pics.length]);
      blocchi.push(row); h+='<div class="kg-k__row"></div>';
    }
    var box=doc.createElement('div');
    box.className='kg-kbox kg-kbox--'+pos+(sec.hasAttribute('data-kg-k3d')?' kg-kbox--3d':'');
    box.innerHTML='<div class="kg-k__rows">'+h+'</div>';
    L.appendChild(box); vel(sec,L); osserva(L);
    var kr=box.firstChild;
    $$('.kg-k__row',box).forEach(function(rw,i){giro(rw,blocchi[i],function(){return kr.offsetWidth},false,sec,kr)});
    var o={sec:sec,box:box,pos:pos,c:pos==='centro'&&!PHONE}; KS.push(o);
    kplace(o);
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(function(){kplace(o)});
    window.addEventListener('load',function(){kplace(o)});
    if(window.ResizeObserver){var t0;new ResizeObserver(function(){clearTimeout(t0);t0=setTimeout(function(){kplace(o)},150)}).observe(sec)}
  });
  if(KS.length&&!REDUCE){
    var kt=false;
    var kpar=function(){
      kt=false; var vh=window.innerHeight;
      KS.forEach(function(o){
        if(!visibile(o.box.parentNode)) return;
        var r=o.sec.getBoundingClientRect();
        /* K nella finestra: al massimo 10 px su/giu' (resta nel suo spazio); K gigante: 40 px */
        var fin=o.box.classList.contains('kg-kbox--finestra'), lim=fin?10:40;
        var p=(r.top+r.height/2-vh/2)/vh, y=Math.max(-lim,Math.min(lim,-p*(fin?16:48)));
        o.box.style.translate=(o.c?'-50% ':'0 ')+y.toFixed(1)+'px';
      });
    };
    window.addEventListener('scroll',function(){if(!kt){kt=true;requestAnimationFrame(kpar)}},{passive:true});
    kpar();
  }

  /* ---------- 6. SOCIAL / WEB: kg-bg--feed ---------- */
  $$('.kg-bg--feed').forEach(function(sec){
    var L=layer(sec,'kg-fl'); if(!L) return;
    var pics=lista(sec), sito=sec.getAttribute('data-kg-feed')==='sito';
    var lato=sec.getAttribute('data-kg-lato')||(sec.classList.contains('kg-split--rev')?'destra':(sec.classList.contains('kg-split')?'sinistra':'tutto'));
    var per=sito?2:3, n=Math.max(per*(sito?5:6),Math.ceil(pics.length/per)*per), h='';
    for(var j=0;j<n;j++)h+=img(pics[j%pics.length]);
    L.innerHTML='<div class="kg-feed kg-feed--'+lato+(sito?' kg-feed--sito':'')+'"><div class="kg-feed__in"></div></div>';
    vel(sec,L.firstChild); osserva(L);
    var fd=L.firstChild; giro(fd.firstChild,h,function(){return fd.offsetHeight},true,sec,fd);
  });

  /* ---------- 7. INSEGNE: kg-bg--insegne ---------- */
  $$('.kg-bg--insegne').forEach(function(sec){
    var L=layer(sec,'kg-insl'); if(!L) return;
    var pics=lista(sec), T=parseInt(sec.getAttribute("data-kg-tessera"),10)||(PHONE?96:112), tiles=[], free=[], last=null;
    function build(){
      var w=sec.offsetWidth, h=sec.offsetHeight, c=Math.max(3,Math.round(w/(T+10))), r=Math.ceil(h/(w/c))+1, s='';
      L.innerHTML='<div class="kg-ins" style="--kg-c:'+c+';--kg-t:'+(w/c-10)+'px"></div>';
      for(var i=0;i<c*r;i++) s+='<div class="kg-ins__t">'+img(pics[(i%c+Math.floor(i/c)*3)%pics.length])+'</div>';
      L.firstChild.innerHTML=s; tiles=$$('.kg-ins__t',L); free=[]; spegni();
    }
    /* le facciate dietro le parole restano spente (AD 13/10): occhiello e link rossi tengono il contrasto pieno */
    function spegni(){
      var rs=testi(sec,'h2,p,.kg-eyebrow,.kg-link,.kg-lead,.kg-small');
      tiles.forEach(function(t){t.classList.toggle('is-sotto',tocca(t.getBoundingClientRect(),rs,4))});
    }
    if(doc.fonts&&doc.fonts.ready) doc.fonts.ready.then(spegni);
    window.addEventListener('load',spegni);
    function liberi(){
      var rs=testi(sec,'p,.kg-eyebrow,.kg-link,.kg-lead,.kg-small'), sr=sec.getBoundingClientRect(), vh=window.innerHeight;
      free=tiles.filter(function(t){var r=t.getBoundingClientRect();return r.bottom>sr.top&&r.top<sr.bottom&&r.bottom>0&&r.top<vh&&r.right>0&&r.left<window.innerWidth&&!tocca(r,rs,6)&&!t.closest('.kg-split__img')&&!tocca(r,$$('.kg-split__img',sec).map(function(x){return x.getBoundingClientRect()}),0)});
    }
    build(); osserva(L);
    if(window.ResizeObserver){var t0;new ResizeObserver(function(){clearTimeout(t0);t0=setTimeout(build,200)}).observe(sec)}
    ogni(L,ritmo(sec,2300),function(){
      liberi(); if(!free.length) return;
      var t=free[Math.floor(Math.random()*free.length)]; if(t===last&&free.length>1) t=free[(free.indexOf(t)+1)%free.length];
      last=t; t.classList.add('is-on'); setTimeout(function(){t.classList.remove('is-on')},2600);
    });
  });

  /* ---------- 8. COME FUNZIONA: kg-bg--passi ---------- */
  $$('.kg-bg--passi').forEach(function(sec){
    var steps=$$('.kg-step',sec); if(!steps.length) return;
    var grid=steps[0].parentNode, pics=lista(sec), tiles=[];
    steps.forEach(function(s,i){
      var t=doc.createElement('div'); t.className='kg-passo'; t.setAttribute('aria-hidden','true');
      t.innerHTML=img(pics[i%pics.length]); grid.insertBefore(t,grid.firstChild); tiles.push(t);
    });
    function place(){
      var py=PHONE?0:22, px=PHONE?0:6;
      steps.forEach(function(s,i){
        var t=tiles[i].style;
        t.left=(s.offsetLeft-px)+'px'; t.top=(s.offsetTop-py)+'px';
        t.width=(s.offsetWidth+px*2)+'px'; t.height=(s.offsetHeight+py*2)+'px';
      });
    }
    place(); setTimeout(place,1200);
    if(window.ResizeObserver) new ResizeObserver(place).observe(grid);
    window.addEventListener('load',place);
    var k=-1;
    function passo(){
      k=(k+1)%steps.length;
      steps.forEach(function(s,i){s.classList.toggle('is-passo',i===k);tiles[i].classList.toggle('is-on',i===k)});
    }
    osserva(sec);
    if(REDUCE){tiles.forEach(function(t){t.classList.add('is-on')});return}
    passo(); ogni(sec,ritmo(sec,2600),passo);
  });

  /* ---------- 9. NUMERI: kg-bg--flip (sulla .kg-stats) ---------- */
  $$('.kg-bg--flip').forEach(function(box){
    var stats=$$('.kg-stat',box); if(!stats.length) return;
    var pics=lista(box);
    stats.forEach(function(s,i){
      var f=doc.createElement('span'); f.className='kg-flip'; f.setAttribute('aria-hidden','true');
      f.innerHTML='<span class="kg-flip__in"><span class="kg-flip__f"></span><span class="kg-flip__b">'+img(pics[i%pics.length])+'</span></span>';
      s.insertBefore(f,s.firstChild);
    });
    function conta(b){
      var t=b.textContent, m=t.match(/^(\D*)(\d+)(.*)$/); if(!m) return;
      var n=parseInt(m[2],10), t0=null;
      b.setAttribute('aria-label',t);
      function f(ts){
        if(t0===null) t0=ts; var p=Math.min(1,(ts-t0)/1400), e=1-Math.pow(1-p,3);
        b.textContent=m[1]+Math.round(n*e)+m[3]; if(p<1) requestAnimationFrame(f);
      }
      requestAnimationFrame(f);
    }
    function via(){
      stats.forEach(function(s,i){
        setTimeout(function(){s.classList.add('is-flip'); var b=s.querySelector(':scope>b'); if(b&&!REDUCE) conta(b)},REDUCE?0:i*180);
      });
    }
    if(REDUCE||!HAS_IO){via();return}
    var io=new IntersectionObserver(function(es){if(es[0].isIntersecting){io.disconnect();via()}},{threshold:.45});
    io.observe(box);
  });

  /* ---------- 10. CATALOGHI: kg-bg--colonne ---------- */
  $$('.kg-bg--colonne').forEach(function(sec){
    var L=layer(sec,'kg-coll'); if(!L) return;
    var pics=lista(sec), c=parseInt(sec.getAttribute('data-kg-colonne'),10)||5; if(PHONE) c=Math.min(c,3);
    var per=Math.max(4,Math.ceil(pics.length/c)+1), h='', blocchi=[];
    for(var i=0;i<c;i++){
      var col='';
      for(var j=0;j<per;j++)col+=img(pics[(i*2+j*c+j)%pics.length]);
      blocchi.push(col); h+='<div class="kg-col__c"></div>';
    }
    L.innerHTML='<div class="kg-col" style="--kg-c:'+c+'">'+h+'</div>';
    vel(sec,L.firstChild); osserva(L);
    /* le colonne pari partono piu' in alto (margin-top negativo): devono coprire anche quel pezzo */
    var grid=L.firstChild;
    $$('.kg-col__c',grid).forEach(function(cc,i){giro(cc,blocchi[i],function(){return grid.offsetHeight-Math.min(0,cc.offsetTop)},true,sec,grid)});
  });

  /* ---------- 11. RECENSIONI: kg-bg--sfocato ---------- */
  $$('.kg-bg--sfocato').forEach(function(sec){
    var L=layer(sec,'kg-sfl'); if(!L) return;
    var pics=lista(sec), h='';
    pics.forEach(function(p,i){h+='<img alt="" decoding="async" loading="lazy"'+(i===0?' class="is-on"':'')+' src="'+src(p,true)+'">'});
    L.innerHTML='<div class="kg-sf">'+h+'</div>'; osserva(L);
    var ims=$$('img',L), k=0;
    if(ims.length>1) ogni(L,ritmo(sec,7000),function(){ims[k].classList.remove('is-on');k=(k+1)%ims.length;ims[k].classList.add('is-on')});
  });

  /* ---------- 12. CTA ROSSA: kg-bg--flash (sopra il mosaico B) ---------- */
  $$('.kg-bg--flash').forEach(function(sec){
    var mos=sec.querySelector(':scope>.kg-mosaic'); if(!mos||REDUCE) return;
    var L=doc.createElement('div'); L.className='kg-bgl kg-flashl'; L.setAttribute('aria-hidden','true');
    L.innerHTML='<div class="kg-flash__t"></div>';
    mos.parentNode.insertBefore(L,mos.nextSibling);
    var t=L.firstChild, ti=doc.createElement('img'), raf=0; ti.alt=''; ti.decoding='async';
    ogni(sec,ritmo(sec,3400),function(){
      var sr=sec.getBoundingClientRect(), rs=testi(sec);
      var cand=$$('img',mos).filter(function(im){
        var r=im.getBoundingClientRect();
        return r.left>sr.left+4&&r.right<sr.right-4&&r.top>=sr.top&&r.bottom<=sr.bottom&&!tocca(r,rs,10);
      });
      if(!cand.length) return;
      var im=cand[Math.floor(Math.random()*cand.length)];
      ti.src=im.currentSrc||im.src; if(!ti.parentNode) t.appendChild(ti);
      var r0=im.getBoundingClientRect(); t.style.width=r0.width+'px'; t.style.height=r0.height+'px';
      t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
      var end=performance.now()+1500;
      cancelAnimationFrame(raf);
      (function track(){ /* la tessera scorre: il flash la segue per 1,5 s */
        var r=im.getBoundingClientRect(), s=sec.getBoundingClientRect();
        t.style.transform='translate('+(r.left-s.left).toFixed(1)+'px,'+(r.top-s.top).toFixed(1)+'px)';
        if(performance.now()<end) raf=requestAnimationFrame(track);
      })();
    });
  });

  /* ---------- 13. FOOTER: kg-bg--micro ---------- */
  $$('.kg-bg--micro').forEach(function(f){
    var L=layer(f,'kg-microl'); if(!L) return;
    var m=doc.createElement('div'); m.className='kg-micro';
    var mot=f.getAttribute('data-kg-motivo'); if(mot) m.style.backgroundImage='url("'+src(mot)+'")';
    L.appendChild(m); vel(f,m); osserva(L);
  });

  /* ---------- 14. MATERIA: kg-bg--materia ---------- */
  $$('.kg-bg--materia').forEach(function(sec){
    var L=layer(sec,'kg-matl'); if(!L) return;
    var n=sec.getAttribute('data-kg-materia')||lista(sec)[0];
    L.innerHTML='<div class="kg-mat">'+img(n)+'</div>'; osserva(L);
  });

  /* le animazioni ripartono/si fermano anche quando cambi scheda */
  doc.addEventListener('visibilitychange',function(){html.classList.toggle('kg-scheda-nascosta',doc.hidden)});

  /* ---------- 15. VELO SOTTO LA TESTATA (art director 13/10) ----------
     Nelle sezioni con intestazione (.kg-head) lo sfondo resta al 30% fino al fondo della testata e torna pieno
     110 px sotto: occhiello rosso, titolo e testo grigio hanno lo stesso contrasto che avrebbero senza sfondo,
     l'effetto vive attorno alle card. Misurato da JS (--kg-testa), si rifa' a ogni cambio di misura.
     Le pagine possono tararlo nel loro <style> con --kg-velo-a o con una maschera propria. */
  var VELO='.kg-acc,.kg-dia,.kg-coll,.kg-fl,.kg-insl,.kg-sfl,.kg-matl';
  $$('.kg-main>.kg-sec').forEach(function(sec){
    var lay=$$(':scope>.kg-bgl',sec).filter(function(l){return l.matches(VELO)}); if(!lay.length) return;
    /* testata: la .kg-head, oppure nelle sezioni split occhiello + titolo della colonna di testo */
    var head=sec.querySelector(':scope>.kg-wrap>.kg-head')||sec.querySelector(':scope>.kg-wrap>.kg-split__txt>h2'); if(!head) return;
    function misura(){
      var t=head.getBoundingClientRect().bottom-sec.getBoundingClientRect().top+8;
      if(t>40&&t<sec.offsetHeight*.7){sec.style.setProperty('--kg-testa',Math.round(t)+'px');sec.classList.add('kg-velo')}
      else sec.classList.remove('kg-velo');
    }
    misura();
    if(doc.fonts&&doc.fonts.ready) doc.fonts.ready.then(misura);
    window.addEventListener('load',misura);
    if(window.ResizeObserver){var t0;new ResizeObserver(function(){clearTimeout(t0);t0=setTimeout(misura,150)}).observe(sec)}
  });
})();
